import { useReducer, createContext } from 'react';
const DownloadContext = new createContext();
export default DownloadContext;

const init = {
    downloading: false, //ΔVΔVΔ: true when map is in process of downloading
    csv: false, //csv checkbox
    map: true, //map checkbox
    filter: 'current',
    printState: false,
    printScope: 'national',
    // printZoom: false,
    csv_link: '',
    map_link: '',
    doc_link: '',
    center: [0, 0],
    zoom: 0
};

const actions = (state, dispatch) => {
    return {
        setcsv_option: (csv) => dispatch({ type: 'setcsv_option', csv }),
        setmap_option: (map) => dispatch({ type: 'setmap_option', map }),
        init_download: () => dispatch({ type: 'init_download' }),
        completeDownload: () => dispatch({ type: 'completeDownload' }),
        setFilter_option: (value) => dispatch({ type: 'setFilter_option', value }),
        setState_option: (value) => dispatch({ type: 'setState_option', value }),
        set_csv_link: (value) => dispatch({ type: 'set_csv_link', value }),
        set_map_link: (value) => dispatch({ type: 'set_map_link', value }),
        set_doc_link: (value) => dispatch({ type: 'set_doc_link', value }),
        setPrintScope: (value) => dispatch({ type: 'setPrintScope', value })
    };
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'setcsv_option':
            return { ...state, csv: action.csv };
        case 'setmap_option':
            return { ...state, map: action.map };
        case 'init_download':
            return { ...state, downloading: true, csv_link: '', map_link: '', doc_link: '' };
        case 'completeDownload':
            return { ...state, downloading: false };
        case 'setFilter_option':
            return { ...state, filter: action.value };
        case 'setState_option':
            return { ...state, printState: action.value, printScope: action.value ? 'state' : 'national' };
        case 'set_csv_link':
            return { ...state, csv_link: action.value };
        case 'set_map_link':
            return { ...state, map_link: action.value };
        case 'set_doc_link':
            return { ...state, doc_link: action.value };
        case 'setPrintScope':
            return { ...state, printScope: action.value };
        default:
            return state;
    }
};

const DownloadProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, { ...init });
    const value = { ...state, ...actions(state, dispatch) };
    return <DownloadContext.Provider value={value}>{children}</DownloadContext.Provider>;
};
export { DownloadProvider };
